import React from "react";
import "./NavMenu.css";
import NavMenuItem from "../NavMenuItem/NavMenuItem";
import Flex from "../Flex/Flex";
import NewsIcon from "../../assets/Icons/NewsIcon.svg?react";
import FAQIcon from "../../assets/Icons/FAQIcon.svg?react";
import MiningIcon from "../../assets/Icons/MiningIcon.svg?react";
import TopPlayersIcon from "../../assets/Icons/TopPlayersIcon.svg?react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NavMenu = React.memo(() => {
  const { t } = useTranslation("translation");
  const location = useLocation();
  const { pathname } = location;

  const menuItems = React.useMemo(
    () => [
      { label: t("news"), icon: <NewsIcon />, link: "/news", isDisabled: true },
      { label: "FAQ", icon: <FAQIcon />, link: "/faq", isDisabled: false },
      {
        label: t("mining"),
        icon: <MiningIcon />,
        link: "/mining",
        isDisabled: true,
      },
      {
        label: t("top_players"),
        icon: <TopPlayersIcon />,
        link: "/top-players",
      },
    ],
    [t]
  );

  return (
    <Flex
      className="NavMenu"
      gap={0}
    >
      {menuItems.map(x => (
        <NavMenuItem
          key={x.label}
          label={x.label}
          link={x.link}
          isActive={pathname === x.link}
          isDisabled={x.isDisabled}
          icon={x.icon}
        />
      ))}
    </Flex>
  );
});

export default NavMenu;
